"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BPMControl = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const lodash_noop_1 = __importDefault(require("lodash.noop"));
function BPMControl({ bpm, isDecreaseBPMAvailable = true, isIncreaseBPMAvailable = true, onIncreaseBPM = lodash_noop_1.default, onDecreaseBPM = lodash_noop_1.default, }) {
    const [disabled, setDisabled] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        setDisabled(false);
    }, [bpm]);
    const onMinus = () => {
        if (disabled) {
            return;
        }
        setDisabled(true);
        onDecreaseBPM();
    };
    const onPlus = () => {
        if (disabled) {
            return;
        }
        setDisabled(true);
        onIncreaseBPM();
    };
    return ((0, jsx_runtime_1.jsxs)(BPMContainer, { "data-e2e": 'BPMControl_BPMContainer', children: [(0, jsx_runtime_1.jsx)(ButtonContainer, { "data-e2e": 'BPMControl_ButtonContainer', children: isDecreaseBPMAvailable && ((0, jsx_runtime_1.jsx)(BPMButton, { onClick: onMinus, disabled: disabled, "data-e2e": 'BPMControl_BPMButton', children: (0, jsx_runtime_1.jsx)(BPMButtonIcon, { name: ui_1.Icons.Tabs_Minus, "data-e2e": 'BPMControl_BPMButtonIcon' }) })) }), (0, jsx_runtime_1.jsx)(TextContainer, { "data-e2e": 'BPMControl_TextContainer', children: (0, jsx_runtime_1.jsxs)(BPMText, { "data-e2e": 'BPMControl_BPMText', children: [(0, jsx_runtime_1.jsxs)(BPMNumber, { "data-e2e": 'BPMControl_BPMNumber', children: [bpm, " "] }), "BPM"] }) }), (0, jsx_runtime_1.jsx)(ButtonContainer, { "data-e2e": 'BPMControl_ButtonContainer', children: isIncreaseBPMAvailable && ((0, jsx_runtime_1.jsx)(BPMButton, { onClick: onPlus, disabled: disabled, "data-e2e": 'BPMControl_BPMButton', children: (0, jsx_runtime_1.jsx)(BPMButtonIcon, { name: ui_1.Icons.Tabs_Plus, "data-e2e": 'BPMControl_BPMButtonIcon' }) })) })] }));
}
exports.BPMControl = BPMControl;
const BPMContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  width: 195px;

  color: ${({ theme }) => theme.text};
`;
const BPMText = styled_components_1.default.p `
  font-size: 15px;

  text-align: center;
`;
const BPMNumber = styled_components_1.default.span `
  font-size: 24px;
`;
const BPMButton = (0, styled_components_1.default)(ui_1.BaseButton) `
  display: flex;
  align-items: center;
  justify-content: center;

  width: 50px;
  height: 50px;
  padding: 0;
`;
const BPMButtonIcon = (0, styled_components_1.default)(ui_1.Icon) `
  width: 55%;
  height: 55%;
`;
const ButtonContainer = styled_components_1.default.div `
  width: 60px;
`;
const TextContainer = styled_components_1.default.div `
  width: 75px;
`;
